import { type FC, useContext, useEffect, useRef } from 'react';
import cn from 'classnames';

import { convertRemToPixels } from '@/common/lib/convertRemtoPx.ts';

import { IntroContext } from '../context.ts';

import { calcAdapteStyles, hightlightComponentStyles } from './config.ts';
import { SvgAnimation } from './SvgAnimation.tsx';

import css from './styles.module.scss';

interface FocusAnimationProps {
  className?: string;
  svgStyles?: {
    rounded: string;
  };
  tapHint?: boolean;
  onClick?: () => void;
  hasCharacter?: boolean;
}

const FocusAnimation: FC<FocusAnimationProps> = ({
  className,
  hasCharacter,
}) => {
  const svgAnimationRef = useRef<SVGRectElement | null>(null);
  const { highlightComponentRect, activeStep } = useContext(IntroContext);

  useEffect(() => {
    const rectComponentIsExist =
      highlightComponentRect &&
      highlightComponentRect.height &&
      highlightComponentRect.width;
    console.log('rect component is exist: ', rectComponentIsExist);
  }, [highlightComponentRect]);

  const rectStyles =
    activeStep in hightlightComponentStyles
      ? calcAdapteStyles(hightlightComponentStyles[activeStep])
      : { padding: 0, rounded: convertRemToPixels(0.5) };

  const rectComponentIsExist =
    highlightComponentRect &&
    highlightComponentRect.height &&
    highlightComponentRect.width;

  return (
    <svg width="100%" height="100%" className={cn(css.base, className)}>
      {!!rectComponentIsExist && (
        <defs>
          <mask id="hole-mask">
            <rect width="100%" height="100%" fill="white" />
            <rect
              style={{
                transformOrigin: 'center',
              }}
              rx={rectStyles.rounded}
              ry={rectStyles.rounded}
              x={
                highlightComponentRect.left -
                rectStyles.padding / 2 +
                (rectStyles.x || 0)
              }
              y={
                highlightComponentRect.top -
                rectStyles.padding / 2 +
                (rectStyles.y || 0)
              }
              width={highlightComponentRect.width + rectStyles.padding}
              height={highlightComponentRect.height + rectStyles.padding}
              transform={
                rectStyles.rounded === '100%' ? 'scale(0.85)' : undefined
              }
              // transform-origin="50% 50%"
              fill="black"
              className="pointer-events-none"
            />
          </mask>
        </defs>
      )}
      {!!hasCharacter && (
        <>
          <linearGradient id="blackToTransparent" x1="0" y1="1" x2="0" y2="0">
            <stop offset="0%" stop-color="black" stop-opacity="1" />
            <stop offset="30%" stop-color="black" stop-opacity="1" />
            <stop offset="100%" stop-color="black" stop-opacity="0" />
          </linearGradient>
          <rect
            width="100%"
            height="100%"
            fill="url(#blackToTransparent)"
            mask="url(#hole-mask)"
            opacity="0.9"
          />
        </>
      )}

      {!!rectComponentIsExist && <SvgAnimation ref={svgAnimationRef} />}
    </svg>
  );
};

export { FocusAnimation };
